// extracted by mini-css-extract-plugin
export var animationContainer = "_bw-0";
export var asteriskIcon = "_bw-8";
export var conversationLeftSection = "_bw-4";
export var conversationListItem = "_bw-3";
export var conversationMiddleSection = "_bw-5";
export var conversationRightSection = "_bw-6";
export var detailsContent = "_bw-1";
export var listContainer = "_bw-7";
export var modalContent = "_bw-2";